import { Link } from "react-router-dom";
import { Heart } from "lucide-react";

export default function PublicFooter() {
  return (
    <footer className="bg-[#2C4C3B] text-[#F7F5F0] mt-24">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 grid md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2 mb-4">
            <div className="w-9 h-9 rounded-full bg-[#9CAF88] flex items-center justify-center">
              <Heart className="w-5 h-5 text-[#2C4C3B]" fill="currentColor" />
            </div>
            <span className="font-display text-xl font-semibold">CareHomeConnect</span>
          </div>
          <p className="text-[#F7F5F0]/70 text-sm leading-relaxed max-w-md">
            Helping families find the right senior care — with clarity, compassion, and no pressure.
          </p>
        </div>
        <div>
          <div className="font-display font-semibold mb-3">Explore</div>
          <ul className="space-y-2 text-sm text-[#F7F5F0]/70">
            <li><Link to="/articles" className="hover:text-white">Articles</Link></li>
            <li><Link to="/quiz" className="hover:text-white">Find care</Link></li>
            <li><Link to="/senior-care" className="hover:text-white" data-testid="footer-states-link">By state</Link></li>
            <li><Link to="/for-partners" className="hover:text-white">For communities</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-display font-semibold mb-3">Account</div>
          <ul className="space-y-2 text-sm text-[#F7F5F0]/70">
            <li><Link to="/login" className="hover:text-white">Sign in</Link></li>
            <li><Link to="/privacy" className="hover:text-white" data-testid="footer-privacy-link">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-white" data-testid="footer-terms-link">Terms of Service</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 px-6 md:px-12 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#F7F5F0]/60">
        <div>© {new Date().getFullYear()} CareHomeConnect. Made with care.</div>
        <div className="flex items-center gap-5">
          <Link to="/privacy" className="hover:text-white">Privacy</Link>
          <Link to="/terms" className="hover:text-white">Terms</Link>
        </div>
      </div>
    </footer>
  );
}
